import React, { useState, useEffect } from "react";
import {
    MDBCard,
    MDBCardBody,
    MDBInput,
    MDBCardFooter,
    MDBValidation,
    MDBBtn,
    MDBIcon,
    MDBSpinner,
  } from "mdb-react-ui-kit";
  import { Link, useNavigate } from "react-router-dom";
  import { useDispatch, useSelector } from "react-redux";
  import {toast} from "react-toastify"
  import { googleSignIn, login } from "../redux/features/authSlice";
  import { GoogleLogin } from "react-google-login";

  // 696938245438-7ae3k7h55fq0ju2l5c6sv4a2ubtork8s.apps.googleusercontent.com

  
  const initialState = {
    email: "",
    password: "",
  };
  
const Login = () => {
    const [formValue, setFormValue] = useState(initialState);
    const { loading, error } = useSelector((state) => ({ ...state.auth }));
    const { email, password } = formValue;
    const dispatch = useDispatch();
    const navigate = useNavigate();
     
  

    const clientId =  '1058221014421-iprm051uoeo8lvpumtu6cuovpm72cq82.apps.googleusercontent.com' 

    useEffect(() => {
      error && toast.error(error);
    }, [error]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (email && password) {
          dispatch(login({ formValue, navigate, toast }));
        }
      };
      const onInputChange = (e) => {
        let { name, value } = e.target;
        setFormValue({ ...formValue, [name]: value });
      };
      const googleSuccess = (resp) => {
        const email = resp?.profileObj?.email;
        const name = resp?.profileObj?.name;
        const token = resp?.tokenId;
        const googleId = resp?.googleId;
        const result = { email, name, token, googleId };
        dispatch(googleSignIn({ result, navigate, toast }));
      };
      const googleFailure = (error) => {
        toast.error(error);
      };
    return (
        <div  style={{
            margin: "auto",
            padding: "15px",
            maxWidth: "450px",
            alignContent: "center",
            marginTop: "120px",
          }}>
         <MDBCard alignment="center" className="pt-4">
         <MDBIcon fas icon="user-circle" className="fa-2x" />
         <h5>Sign In</h5>
         
         <MDBCardBody>
         <MDBValidation onSubmit={handleSubmit} noValidate className="row g-3">
         
         <div className="col-md-12">
         <span style={{
            color : 'green'
          }}>Please Login with -</span> <br />
             <small>Email: admin@gmail.com</small> <br />
             <small>Password: 123456</small>

              <MDBInput
                className="mt-3"
                type="email"
                value={email}
                name="email"
                onChange={onInputChange}
                required
                invalid
                validation="Please provide your email"
              />
            </div>
            <div className="col-md-12">
              <MDBInput
                label="Password"
                type="password"
                value={password}
                name="password"
                onChange={onInputChange}
                required
                invalid
                validation="Please provide your password"
              />
            </div>
            <div className="col-12">
              <MDBBtn style={{ width: "100%" }} className="mt-2">
              {loading && (
                  <MDBSpinner
                    size="sm"
                    role="status"
                    tag="span"
                    className="me-2"
                  />
                )}
                Login
              </MDBBtn>
            </div>
         </MDBValidation> 
        
         
        </MDBCardBody>
         <MDBCardFooter>
          <Link to="/register">
            <p>Don't have an account ? Sign Up</p>
          </Link>
        </MDBCardFooter> 
         </MDBCard>    

        </div>
    );
};

export default Login;